/* eslint-disable */
import React, { useState } from 'react';
import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';
import { FormDropdown, RegularButton, AlertAdapter, IconButton } from 'pg-ui-library';
import { Formik, FormikHelpers } from 'formik';
import { IPersonalInformation } from 'src/interfaces/personal-info';
import emailSvg from 'src/assets/email.svg';
import personDark from 'src/assets/personDark.svg';

import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { alphabetRegex } from 'src/utils/alphabetRegex';
import ProfilePicture from 'src/components/profile-picture';
import personalInfoService from 'src/services/personal-info.service';
import { PersonalInfoForm, genderOptions, maritalStatusOptions } from '../..';
import {
  Container,
  EmploymentInfo,
  FormInput,
  FormInputContainer,
  FormRow,
  FormTitle,
  Separator,
  FormTitleItem,
  GeneralInfo,
  GeneralInfoFormContainer,
  PersonalInfoFormContainer,
  PersonalInfoHeader,
  FormInputLabel,
  SeparatorLineStraight,
  InputContainer,
  PersonelInputLabel,
  EmailIcon,
  PersonelInputContainer,
} from './styles';
import { PersonalUserModal } from '../personal-user-modal';
import { DistributionModal } from 'src/components';

const GeneralInfoForm: React.FC<PersonalInfoForm> = ({ personalInfo }) => {
  const { t } = useTranslation();

  const generalInfoSchema = yup.object({
    firstName: yup
      .string()
      .matches(alphabetRegex, t('global.form.alphabet'))
      .required(t('global.form.required'))
      .min(2)
      .max(20),
    middleName: yup.string().matches(alphabetRegex, t('global.form.alphabet')).max(20),
    lastName: yup
      .string()
      .matches(alphabetRegex, t('global.form.alphabet'))
      .required(t('global.form.required'))
      .min(2)
      .max(20),
    birthDate: yup.date(),
    gender: yup.string().required(t('global.form.required')),
    maritalStatus: yup.string().required(t('global.form.required')),
  });
  const [userModalIsOpen, setUserModalIsOpen] = useState<boolean>(false);
  const firstNameValue = `${personalInfo?.firstName ?? ''} ${personalInfo?.lastName ?? ''}`;
  const userName = personalInfo?.username || '';
  const userEmail = personalInfo?.address.secondaryEmail || '';

  const onSubmit = async (
    values: Partial<IPersonalInformation>,
    // eslint-disable-next-line no-unused-vars
    { setSubmitting }: FormikHelpers<Partial<IPersonalInformation>>
  ) => {
    try {
      await personalInfoService.patchPersonalInformation({ ...values });
      AlertAdapter('General information updated', 'success');
    } catch (error: any) {
      AlertAdapter(error.response.data.message ?? 'Error during updating general information', 'error');
    }
  };

  const [hideData, setHideData] = useState<boolean>(true);
  const dataShow = (e: any) => {
    e.preventDefault();
    setHideData(!hideData);
  };

  const getDisplayValue = (value: any, field: string) => {
    if (!hideData) return value;
    switch (field) {
      case 'firstName':
      case 'middleName':
      case 'lastName':
      case 'birthDate':
      case 'gender':
      case 'maritalStatus':
        return '*******';
      case 'ssn':
        return '***-**-****';
      case 'username':
        return '********';
      case 'birthDate':
        return '**/**/****';
      default:
        return '*****';
    }
  };
  return (
    <>
      <PersonalUserModal isOpen={userModalIsOpen} setIsOpen={setUserModalIsOpen} />
      <div style={{ display: 'flex' }}>
        <div style={{ flex: '1', padding: '10px 0px 10px 0px', width: '22%' }}>
          <PersonalInfoHeader>
            <div style={{ display: 'flex', alignItems: 'center', paddingTop: '25px' }}>
              <div style={{ marginRight: '20px' }}>
                <ProfilePicture editing />
              </div>
            </div>
            <InputContainer>
              <div>
                <p>{firstNameValue}</p>
              </div>
            </InputContainer>

            <PersonelInputContainer>
              <PersonelInputLabel>User Name</PersonelInputLabel>
              <EmailIcon src={personDark} />
            </PersonelInputContainer>
            <PersonelInputContainer style={{ marginTop: '-10%' }}>
              <input type="text" value={userName} placeholder="" />
            </PersonelInputContainer>
            <PersonelInputContainer>
              <PersonelInputLabel>Personal Email</PersonelInputLabel>
              <EmailIcon src={emailSvg} />
            </PersonelInputContainer>
            <PersonelInputContainer style={{ marginTop: '-11%' }}>
              <input type="text" value={userEmail} placeholder="" style={{ marginTop: '5px' }} />
            </PersonelInputContainer>

            <RegularButton
              type="button"
              onClick={() => setUserModalIsOpen(true)}
              style={{ marginRight: '30px', margin: '0.5em 0.5em 2em 0.5em' }}
            >
              {t('personalInfo.generalInfo.changeUserInfo')}
            </RegularButton>
          </PersonalInfoHeader>
        </div>

        <div style={{ flex: '2', padding: '10px', width: '73%', marginLeft: '1%', paddingRight: '0px' }}>
          <Formik
            enableReinitialize
            initialValues={{
              id: personalInfo?.id || '',
              firstName: getDisplayValue(personalInfo?.firstName || '', 'firstName'),
              middleName: getDisplayValue(personalInfo?.middleName || '', 'middleName'),
              lastName: getDisplayValue(personalInfo?.lastName || '', 'lastName'),
              birthDate: getDisplayValue(personalInfo?.birthDate || '', 'birthDate'),
              ssn: getDisplayValue(personalInfo?.ssn || '', 'ssn'),
              gender: getDisplayValue(personalInfo?.gender || '', 'gender'),
              maritalStatus: getDisplayValue(personalInfo?.maritalStatus || '', 'maritalStatus'),
              employeeNickId: personalInfo?.employeeNickId || '',
              employeeClass: personalInfo?.employeeClass || '',
              hireDate: personalInfo?.hireDate || '',
              username: getDisplayValue(personalInfo?.username || '', 'username'),
              secondaryEmail: personalInfo?.address.secondaryEmail || '',
              personalEmail: personalInfo?.address.personalEmail || '',
              primaryPhone: personalInfo?.primaryPhone || '',
              secondaryPhone: personalInfo?.secondaryPhone || '',
              phone1: personalInfo?.address.phone1 || '',
              phone2: personalInfo?.address.phone2 || '',
            }}
            validationSchema={generalInfoSchema}
            onSubmit={onSubmit}
          >
            {({ handleSubmit, errors }) => (
              <Container onSubmit={handleSubmit}>
                <GeneralInfo>
                  <FormTitle>
                    <FormTitleItem>{t('personalInfo.generalInfo.generalInfoTitle')}</FormTitleItem>
                    {hideData ? (
                      <IconButton
                        onClick={dataShow}
                        style={{ width: '50px', height: '40px', padding: '2px', marginRight: '27px' }}
                      >
                        <IoEyeOffOutline size="2rem" style={{ margin: 0, width: 30, height: 30, padding: 2 }} />
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={dataShow}
                        style={{ width: '50px', height: '40px', padding: '2px', marginRight: '27px' }}
                      >
                        <IoEyeOutline size="2rem" style={{ margin: 0, width: 30, height: 30, padding: 2 }} />
                      </IconButton>
                    )}
                  </FormTitle>
                  <SeparatorLineStraight />
                  <FormRow>
                    <GeneralInfoFormContainer>
                      <FormInputContainer>
                        <FormInputLabel>{t('personalInfo.generalInfo.firstName')}</FormInputLabel>
                        <FormInput label="" id="firstName" name="firstName" hasError={!!errors.firstName} />
                      </FormInputContainer>
                      <FormInputContainer>
                        <FormInputLabel>{t('personalInfo.generalInfo.middleName')}</FormInputLabel>
                        <FormInput label="" id="middleName" name="middleName" hasError={!!errors.middleName} />
                      </FormInputContainer>
                      <FormInputContainer>
                        <FormInputLabel>{t('personalInfo.generalInfo.lastName')}</FormInputLabel>
                        <FormInput label="" id="lastName" name="lastName" hasError={!!errors.lastName} />
                      </FormInputContainer>

                      <FormInputContainer>
                        <FormInputLabel>SSN</FormInputLabel>
                        <FormInput label="" id="ssn" name="ssn" />
                      </FormInputContainer>
                      <FormInputContainer>
                        <FormInputLabel>{t('personalInfo.generalInfo.birthDate')}</FormInputLabel>
                        <FormInput label="" id="birthDate" name="birthDate" />
                      </FormInputContainer>

                      <FormInputContainer>
                        <FormInputLabel>{t('personalInfo.generalInfo.gender')}</FormInputLabel>
                        {hideData ? (
                          <FormInput label="" id="gender" name="gender" />
                        ) : (
                          <FormDropdown id="gender" name="gender" label="" options={genderOptions} />
                        )}
                      </FormInputContainer>

                      <FormInputContainer>
                        <FormInputLabel>{t('personalInfo.generalInfo.maritalStatus')}</FormInputLabel>
                        {hideData ? (
                          <FormInput label="" id="maritalStatus" name="maritalStatus" />
                        ) : (
                          <FormDropdown
                            id="maritalStatus"
                            name="maritalStatus"
                            label=""
                            options={maritalStatusOptions}
                          />
                        )}
                      </FormInputContainer>
                      <FormInputContainer style={{ width: '32rem' }}>
                        <FormInputLabel>{t('personalInfo.generalInfo.username')}</FormInputLabel>
                        <FormInput label="" id="username" name="username" />
                      </FormInputContainer>
                    </GeneralInfoFormContainer>
                  </FormRow>
                </GeneralInfo>
                <SeparatorLineStraight />
                <EmploymentInfo>
                  <FormTitle>
                    <FormTitleItem style={{ margin: '0px 10px 20px 0px' }}>
                      {t('personalInfo.generalInfo.employementInfoTitle')}
                    </FormTitleItem>
                  </FormTitle>
                  <SeparatorLineStraight />
                  <PersonalInfoFormContainer>
                    <FormInputContainer>
                      <FormInputLabel>{t('personalInfo.generalInfo.employeeNickId')}</FormInputLabel>
                      <FormInput label="" id="employeeNickId" name="employeeNickId" />
                    </FormInputContainer>
                    <FormInputContainer style={{ marginLeft: '-21%' }}>
                      <FormInputLabel>{t('personalInfo.generalInfo.hireDate')}</FormInputLabel>
                      <FormInput label="" id="hireDate" name="hireDate" />
                    </FormInputContainer>
                    <FormInputContainer style={{ marginLeft: '-15%' }}>
                      <FormInputLabel>{t('personalInfo.generalInfo.employeeClass')}</FormInputLabel>
                      <FormInput
                        label=""
                        id="employeeClass"
                        name="employeeClass"
                        style={{ width: '-webkit-fill-available' }}
                      />
                    </FormInputContainer>
                    <FormInputContainer>
                      <FormInputLabel>{t('personalInfo.address.phone1')}</FormInputLabel>
                      <FormInput label="" id="phone1" name="phone1" />
                    </FormInputContainer>
                    <FormInputContainer>
                      <FormInputLabel>{t('personalInfo.address.phone2')}</FormInputLabel>
                      <FormInput label="" id="phone2" name="phone2" />
                    </FormInputContainer>
                    <FormInputContainer style={{ marginLeft: '-21%' }}>
                      <FormInputLabel>{t('personalInfo.address.businessEmail')}</FormInputLabel>
                      <FormInput label="" id="personalEmail" name="personalEmail" style={{ minWidth: '250px' }} />
                    </FormInputContainer>
                    <FormInputContainer style={{ marginLeft: '-15%' }}>
                      <FormInputLabel>{t('personalInfo.address.secondaryEmail')}</FormInputLabel>
                      <FormInput
                        label=""
                        id="secondaryEmail"
                        name="secondaryEmail"
                        hasError={!!errors.secondaryEmail}
                      />
                    </FormInputContainer>
                  </PersonalInfoFormContainer>
                </EmploymentInfo>
              </Container>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default GeneralInfoForm;
